import React, { Component } from "react";
import { Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import SocialAccountList from "./SocialAccountList";
import SocialAccountCard from "./Social Account/SocialAccountCard";
import {  DELETE_USER_SOCIAL_ACCOUNT, SHARE_CONNECTION_URL, GET_SOCIAL_ACCOUNT_DATA} from "../../../../../actions/accountsActions";
import { emailValidation, SWAL_FIRE, TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS , baseUrl, getInitialRoute , isAppleSafari} from "../../../../../utils";
import AddAccountPopup from "./Modals/AddAccountPopup";
import AccountHeading from "./AccountHeading";
import IconComponent from "./IconComponent";
import ShareByEmailPopup from "./Modals/ShareByEmailPopup"; 
import { addUserAccount } from "../../../../Authorization/SocialAuth/connectSocialAcc";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class SocialAccount extends Component {
  state = {
    allSocialAccounts: this.props.socialAccounts,
    addAccountPopup: false,
    shareAccount: false,
    errorShareAccount: null,
    isSharingEmail: false,
    shareEmails: '',
    copyShareTxt: 'Copy to clipboard'
  };

  componentDidMount() {
    const { socialAccounts } = this.props;
    this.setState({ allSocialAccounts: socialAccounts });
    channel.addEventListener('message', this.readAuthenticationCode)

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.socialAccounts !== this.state.allSocialAccounts) {
      this.setState({ allSocialAccounts: nextProps.socialAccounts });
    }
  }

  deleteSocialAccount = (item) => (event) => {
    SWAL_FIRE({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#FF4051",
      cancelButtonColor: "#E4E6EF",
    }).then((result) => {
      if (result.value) {
        this.props.DELETE_USER_SOCIAL_ACCOUNT(item.ConnectedAccounts.id, item.Network.id, this.onSaveCallBack);
      } else if (result.dismiss === "cancel") {
      }
    });
  };

  onSaveCallBack = (errorMsg = null) => {
    if(!errorMsg){
      const { socialAccounts } = this.props;
      TOAST_SUCCESS("Account successfully disconnected.");
      this.setState({ allSocialAccounts: socialAccounts });
    }else TOAST_ERROR(errorMsg);
   
    setTimeout(() => TOAST_DISMISS(), 3000)
  };


  openAddAccountPopup = () => {
    const { addAccountPopup } = this.state;
    this.setState({ addAccountPopup: !addAccountPopup });
  };

  openShareAccount = () => {
    const { shareAccount } = this.state;
    this.setState({ shareAccount: !shareAccount, errorShareAccount: null });
  };

  copyEmbedCode = () => {
    var c = document.getElementById("copyEmbedCode");
    c.select();
    document.execCommand("copy");
    this.setState({ copyShareTxt: 'Copied' });
    setTimeout(() => {
      this.setState({ copyShareTxt: 'Copy to clipboard' });
    }, 2000);

  };

  ValidateEmails = () => {
    this.setState({ isSharingEmail: true })
    const { allSocialAccounts, shareEmails } = this.state;
    if (shareEmails) {
      var emailList = shareEmails.trim().split(",");
      var isallEmailvalid = emailList.length > 0 && emailList.length <= 5 ? true : false;
      var emailIds = [];
      for (var i = 0; i < emailList.length; i++) {
        const email = emailList[i].trim();
        if (isallEmailvalid && email) {
          isallEmailvalid = emailValidation(email)
          emailIds.push(email);
        } else isallEmailvalid = false;
      }
      if (isallEmailvalid) {
        const shareURL = allSocialAccounts.shareUrl;
        SHARE_CONNECTION_URL({ emailIds, shareURL })
          .then((response) => {
            const { responseCode } = response.data;
            if (responseCode == 200) {
              TOAST_SUCCESS("Connection URL successfully shared.");
              this.setState({ shareAccount: false });
            }
          })
          .catch((error) => {
            if (error?.response?.data?.responseCode == 404) {
              this.setState({
                wallError: true,
                submitErrorMessage: error?.response?.data?.responseMessage ?? "",
                apiRequest: false,
              });
            }
            TOAST_ERROR(error?.response?.data?.responseMessage ?? "");
          });
      } else {
        this.setState({ errorShareAccount: "Invalid email format" });
      }
    } else {
      this.setState({ errorShareAccount: "This field is required." });
    }
    this.setState({ isSharingEmail: false })
  };

  readAuthenticationCode = (event) => {
    const response = JSON.parse(event.data);
    const { data, networkId, type } = response;
    const { userData } =  this.props.authorized;
    const reconnect = localStorage.getItem('refresh');

    const userhashId = userData && Object.keys(userData).length > 0 ? userData.user && Object.keys(userData.user).length > 0 ? userData.user.userhashId : 0 : 0;
    let ownerId = localStorage.getItem('ownerId');

    if (type == "socialConnect") {
      addUserAccount(networkId, data, () => this.props.getSocialAccounts(userhashId), ownerId, 0, Number(reconnect));
    }
    localStorage.removeItem('refresh');
  }

  componentWillUnmount() {
    channel.removeEventListener("message", this.readAuthenticationCode);
  }

  render() {
    const { allSocialAccounts, addAccountPopup, shareAccount, errorShareAccount, isSharingEmail, copyShareTxt, shareEmails } = this.state;
    const { addAccountData } = this.props;
    const sData =
      allSocialAccounts &&
        allSocialAccounts.accountInformations &&
        allSocialAccounts.accountInformations.length > 0
        ? true
        : false;

    return (
      <>
        <div className="card card-custom">
          <div className="card-header flex-wrap py-3 justify-content-end">
            <div className="card-toolbar">
              <Button variant="primary" data-bs-toggle="modal" id="addAccount" data-target="#addAccount" onClick={this.openAddAccountPopup}>
                <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'fs-6 me-2'} />
                Add Account
              </Button>
            </div>
          </div>

          <div className="card-body p-3">
            {sData ? (
              <div className="table-responsive">
                <div className="accordion accordion-light accordion-svg-toggle conn_accounts_wrap"
                  id="connectedAccounts">
                  <SocialAccountList />
                  <div className="connectedAccounts">
                    {allSocialAccounts &&
                      allSocialAccounts.accountInformations.map(
                        (item, index) => (
                          (item && Object.keys(item).length > 0) ?  <SocialAccountCard
                            item={item}
                            index={index}
                            key={index}
                            deleteSocialAccount={this.deleteSocialAccount}
                          /> : null
                        )
                      )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="no_connected_acc">
                <Image src={baseUrl(`products/product-empty.svg`)} className="mb-10 img-fluid"/>
                <AccountHeading title={"Account Not Connected"} />
              </div>
            )}
          </div>

          <div className="border-top py-4 px-3">
              <p className="font-size-sm bg-light p-3">NOTE: Socialwalls does not have the option to access, store, or view personal information and passwords that you may use to connect your social media accounts.</p>
              <p className="">Wondering how to connect an account you don't have access to? Send the following URL to the account's owner:</p>
              <div className="position-relative d-flex align-items-center flex-wrap embed_code input_copy">
                <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>{copyShareTxt}</Tooltip>} >
                  <input type="text" className="form-control w-auto overflow-hidden text-nowrap mb-2 me-3 copyButton" style={{ minWidth: "20vw" }} id="copyEmbedCode"
                    onClick={this.copyEmbedCode} value={ allSocialAccounts && allSocialAccounts.shareUrl ? allSocialAccounts.shareUrl.replace('/widget/', `/`) : ""}/>
                </OverlayTrigger>
                <div className="emebed_action">
                  <Button variant="primary" className="copy-btn mb-2" id="shareCode" data-target="#shareCode" data-toggle="modal" onClick={this.openShareAccount}>
                    Share
                  </Button>
                </div>
              </div>
            </div>
        </div>

        <AddAccountPopup
          openAddAccountPopup={this.openAddAccountPopup}
          addAccountPopup={addAccountPopup}
          addAccountData={addAccountData}
        //  authorized={authorized}
        />

        <ShareByEmailPopup shareAccount={shareAccount} emails={shareEmails} handleEmail={(e) => this.setState({ shareEmails: e.target.value})} errorShareAccount={errorShareAccount} ValidateEmails={this.ValidateEmails} isSharingEmail={isSharingEmail} openShareAccount={this.openShareAccount} />

      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    addAccountData: state.userAccountData.addAccount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DELETE_USER_SOCIAL_ACCOUNT: (feedId, networkId, callBack) => dispatch(DELETE_USER_SOCIAL_ACCOUNT(feedId, networkId, callBack)),
    getSocialAccounts: (userId) => dispatch(GET_SOCIAL_ACCOUNT_DATA(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialAccount);
